import { render, staticRenderFns } from "./OvopExploreChinaDashboard.vue?vue&type=template&id=27d86ccf&scoped=true&"
import script from "./OvopExploreChinaDashboard.vue?vue&type=script&lang=js&"
export * from "./OvopExploreChinaDashboard.vue?vue&type=script&lang=js&"
import style0 from "./OvopExploreChinaDashboard.vue?vue&type=style&index=0&id=27d86ccf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d86ccf",
  null
  
)

export default component.exports